// What a trade's state MEANS to a trader, for the common views (Active Trades, Positions).
// Display only: it reads the engine's own status and open quantity, and changes nothing.

const TONE_CLASS = {
  good: "bg-[#00C805]/15 text-[#00C805]",
  busy: "bg-[#FFCC00]/15 text-[#9a7200]",
  attention: "bg-[#FF9500]/20 text-[#FF9500]",
  bad: "bg-[#FF3B30]/20 text-[#FF6b62]",
  done: "bg-[#475569]/25 text-slate-400",
  idle: "bg-[#2563EB]/15 text-[#5b9bff]",
};

export const toneClass = (tone) => TONE_CLASS[tone] || TONE_CLASS.done;

/** {label, tone, title, attention} for a Futures trade view (from /paper/v25/trades or a position row). */
export function futuresTradeState(t) {
  const open = Number(t.open_levels || 0) > 0 || Number(t.filling_levels || 0) > 0 || Number(t.open_qty || 0) > 0;
  switch (t.status) {
    case "RUNNING":
      return { label: "RUNNING", tone: "good", title: "The strategy is managing this trade: entries and exits run automatically." };
    case "EXITING":
      return { label: "SQUARING OFF", tone: "busy", title: "The position is being closed. It finishes on its own." };
    case "STOPPED":
      return open
        ? { label: "STOPPED · POSITION OPEN", tone: "attention", attention: true,
          title: "The strategy is stopped: it takes no new entries and does NOT exit automatically, but the position is still open. Square it off, or Start the trade again to resume management." }
        : { label: "STOPPED", tone: "done", title: "Stopped, nothing open." };
    case "COMPLETE":
      return { label: "COMPLETE", tone: "done", title: "Cycle finished; nothing open." };
    case "READY":
      return { label: "READY", tone: "idle", title: "Configured, not started." };
    case "RESETTING":
      return { label: "RESETTING", tone: "busy", title: "Resetting to start a new cycle." };
    default:
      return { label: t.status || "—", tone: "done", title: "" };
  }
}
